export default __webpack_public_path__ + "static/media/left.51a79362.svg";